import { render, staticRenderFns } from "./NewInbox.vue?vue&type=template&id=4cb55a74&scoped=true&"
import script from "./NewInbox.vue?vue&type=script&lang=js&"
export * from "./NewInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb55a74",
  null
  
)

export default component.exports